package org.example.willfreightnew

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextIndent
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.color
import com.varabyte.kobweb.compose.css.margin
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.layout.HorizontalDividerStyle
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.*
import com.varabyte.kobweb.silk.style.addVariantBase
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import com.varabyte.kobweb.silk.theme.modifyStyleBase
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.hueRotate
import com.varabyte.kobweb.silk.theme.colors.ColorPalette
import org.example.willfreightnew.components.util.Constants
import org.jetbrains.compose.web.css.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint

@InitSilk
fun initSiteStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle("html") {
        cssRule(CSSMediaQuery.MediaFeature("prefers-reduced-motion", StylePropertyValue("no-preference"))) {
            Modifier.scrollBehavior(ScrollBehavior.Smooth)
        }
    }

    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .fontFamily(
                "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
                "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "sans-serif"
            )
            .fontSize(18.px)
            .lineHeight(1.5)
    }

    // Full width dividers
    ctx.theme.modifyStyleBase(HorizontalDividerStyle) {
        Modifier.fillMaxWidth()
    }
}

val HeadlineTextStyle = CssStyle.base {
    Modifier
        .fontFamily(Constants.FONT_FAMILY)
        .font {  }
        .fontSize(200.percent)
        .textAlign(TextAlign.Start)
        .lineHeight(1.2) //1.5x doesn't look as good on very large text
        .textShadow(0.2.px, 0.2.px, blurRadius = 0.1.cssRem, color = Colors.DimGray)
        .fontWeight(FontWeight.Bold)
}

val SubheadlineTextStyle = CssStyle.base {
    Modifier
        .fontSize(1.cssRem)
        .textAlign(TextAlign.Start)
        .color(colorMode.toPalette().color.toRgb().copyf(alpha = 0.8f))
}

val CircleButtonVariant = ButtonStyle.addVariantBase {
    Modifier.padding(0.px).borderRadius(50.percent)
}

val UncoloredButtonVariant = ButtonStyle.addVariantBase {
    Modifier.setVariable(ButtonVars.BackgroundDefaultColor, Colors.Transparent)
}

val HeaderLinkStyle = CssStyle {
    base {
        Modifier
            .color(Colors.White)
            .transition(Transition.of("color", duration = 300.ms))

    }

//    hover {
//        Modifier
//            .color(Colors.Black)
//    }

}

val HeaderUnderlineStyle = CssStyle {
    base {
        Modifier
    }
}

val ServiceCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(colorMode.toSitePalette().background)
            .transition(Transition.of("backgroundColor", delay = 500.ms))
            .border(
                width = 1.px,
                color = colorMode.toSitePalette().background
            )
    }
    hover {
        Modifier
            .backgroundColor(colorMode.toSitePalette().nearBackground)
            .border(
                width = 2.px,
                color = rgb(175, 0, 0)
            )

    }

    cssRule(" > #iconBox") {
        Modifier
            .backgroundColor(Colors.White)
    }

    cssRule(" > #divider-line") {
        Modifier
            .backgroundColor(colorMode.toSitePalette().faint)
            .width(80.px)
            .transition(Transition.of("backgroundColor", duration = 300.ms))
            .transition(Transition.of("width", duration = 300.ms))
    }

    cssRule(":hover > #divider-line") {
        Modifier
            .width(200.px)
            .backgroundColor(colorMode.toSitePalette().brand.accent)
    }
}

val ContactCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(colorMode.toSitePalette().background)
            .transition(Transition.of("backgroundColor", delay = 500.ms))
            .border(
                width = 1.px,
                color = colorMode.toSitePalette().background
            )
    }
    hover {
        Modifier
            .backgroundColor(colorMode.toSitePalette().nearBackground)
            .border(
                width = 2.px,
                color = rgb(175, 0, 0)
            )

    }

    cssRule(" > #iconBox") {
        Modifier
            .backgroundColor(Colors.White)
    }

    cssRule(" > #divider-line") {
        Modifier
            .backgroundColor(colorMode.toSitePalette().nearBackground)
    }

    cssRule(":hover > #divider-line") {
        Modifier.backgroundColor(colorMode.toSitePalette().brand.accent)
    }
}

val NavLinkStyle = CssStyle {
    base {
        Modifier
            .color(colorMode.toSitePalette().brand.primary)
            .transition(Transition.of("color", 300.ms))
            .transition(Transition.of("backgroundColor", 300.ms))
    }
    hover {
        Modifier
            .backgroundColor(colorMode.toSitePalette().brand.accent)
            .borderRadius(5.px)
            .color(SitePalettes.dark.brand.primary)
    }
}

val BackToTopStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(ColorMode.DARK.toSitePalette().brand.accent)
            .transition(Transition.of(property = "backgroundColour", duration = 200.ms))
    }
    hover {
        Modifier.backgroundColor(Colors.White)
    }
}